module.exports = {
  background: "#25274D",
  text: "#AAABB8",
  white: "#AAABB8",
  accent: "#2E9CCA",
  bright: "#ffffff",
  dark: "#464866",
  gray: "#29648A",
  lightGray: "#29648A",
  superLightGray: "#29648A",
  sideBackground: "#25274D",
  sideText: "#AAABB8"
};

/*
  dark blue - #25274D
  dark blue gray - #464866
  gray white - #AAABB8
  sky blue - #2E9CCA
  blue green gray - #29648A
*/



// WEBPACK FOOTER //
// ./src/styles/colors.js